import {Action} from '@ngrx/store';
import * as _ from 'lodash';

import {CampaignTagsListActionTypes, LoadCampaignTagsListSuccessAction} from '../actions/campaign-tags';
import {TagsList} from '../models/tags-list';

export interface CampaignTagsState {
  array: TagsList[];
}

const initialState: CampaignTagsState = {
  array: []
};

export function campaignTagsReducer(state = initialState, action: Action): CampaignTagsState {
  switch (action.type) {
    case CampaignTagsListActionTypes.LOAD_SUCCESS:
      return handleLoadSuccessAction(state, action);
    case CampaignTagsListActionTypes.LOAD_FAIL:
      return handleLoadFailAction(state);
    default:
      return state;
  }
}

function handleLoadSuccessAction(state: CampaignTagsState, action: LoadCampaignTagsListSuccessAction): CampaignTagsState {
  const newState = _.clone(state);
  newState.array = action.payload.array;
  return newState;
}

function handleLoadFailAction(state: CampaignTagsState): CampaignTagsState {
  const newState = _.clone(state);
  newState.array = [];
  return newState;
}

export const campaignTagsSelectors = {
  array: (state: CampaignTagsState) => _.get(state, 'array', [])
};
